import React from 'react';
import { formatDate } from 'helpers/utils';

// Cell renderer for dates
const DateRenderer = (params) => {
  if (!params.value) return <span className="tw-text-slate-500">-</span>;
  return formatDate(params.value);
};

export default DateRenderer;